import { Helmet } from 'react-helmet-async';

export default function SiteNavigationSchema() {
  const navItems = [
    { name: 'Home', url: 'https://ionicerrrrscode.com/' },
    { name: 'About', url: 'https://ionicerrrrscode.com/about' },
    { name: 'Team', url: 'https://ionicerrrrscode.com/team' },
    { name: 'Technologies', url: 'https://ionicerrrrscode.com/technologies' },
    { name: 'Projects', url: 'https://ionicerrrrscode.com/projects' },
    { name: 'Contact', url: 'https://ionicerrrrscode.com/contact' },
  ];

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: navItems.map((item, index) => ({
      '@type': 'SiteNavigationElement',
      position: index + 1,
      name: item.name,
      url: item.url,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(itemList)}
      </script>
    </Helmet>
  );
}
